import './Loader.css';

export interface LoaderProps {
  heightSection: string;
  position?: 'center' | 'start';
  label?: string;
}

export default function Loader({
  heightSection,
  position = 'center',
  label,
}: LoaderProps) {
  // ==========================================================================
  // General
  // ==========================================================================

  return (
    <>
      <div
        className="loader"
        style={{ height: `${heightSection}`, alignItems: `${position}` }}
      >
        <p className="loader-label">{label}</p>
        <svg viewBox="25 25 50 50" className="svg-loader">
          <circle r="20" cy="50" cx="50" className="circle-loader"></circle>
        </svg>
      </div>
    </>
  );
}
